module.exports = "<h4 class=\"gw-coverage-header\">\n    <span>{{'quoteandbind.pa.directives.pa-line-coverages.General Coverages' | translate}}</span>\n    <span>{{'quoteandbind.pa.directives.pa-line-coverages.(Apply to all vehicles)' | translate}}</span>\n</h4>\n\n<div gw-qnb-readonly-coverages=\"model.lineCoverages\"></div>\n\n<div ng-repeat=\"vehicle in model.vehicleCoverages\">\n    <h4 class=\"gw-coverage-header\">{{ vehicle.vehicleName }}</h4>\n\n    <div class=\"gw-quote-boxes\">\n        <div gw-qnb-readonly-coverages=\"vehicle.coverages\"></div>\n    </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/pa/directives/templates/pa-view-coverages.html
 ** module id = 354
 ** module chunks = 0
 **/